"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreDocumentCheckStepToJSON = exports.PreDocumentCheckStepFromJSONTyped = exports.PreDocumentCheckStepFromJSON = void 0;
const runtime_1 = require("../runtime");
function PreDocumentCheckStepFromJSON(json) {
    return PreDocumentCheckStepFromJSONTyped(json, false);
}
exports.PreDocumentCheckStepFromJSON = PreDocumentCheckStepFromJSON;
function PreDocumentCheckStepFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'photoId': json['photoId'],
        'document': !runtime_1.exists(json, 'document') ? undefined : json['document'],
        'namesOnDocumentsMatch': !runtime_1.exists(json, 'namesOnDocumentsMatch') ? undefined : json['namesOnDocumentsMatch'],
        'membershipNameMatchesLegalName': !runtime_1.exists(json, 'membershipNameMatchesLegalName') ? undefined : json['membershipNameMatchesLegalName'],
        'citizenshipChanged': !runtime_1.exists(json, 'citizenshipChanged') ? undefined : json['citizenshipChanged'],
    };
}
exports.PreDocumentCheckStepFromJSONTyped = PreDocumentCheckStepFromJSONTyped;
function PreDocumentCheckStepToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'photoId': value.photoId,
        'document': value.document,
        'namesOnDocumentsMatch': value.namesOnDocumentsMatch,
        'membershipNameMatchesLegalName': value.membershipNameMatchesLegalName,
        'citizenshipChanged': value.citizenshipChanged,
    };
}
exports.PreDocumentCheckStepToJSON = PreDocumentCheckStepToJSON;
//# sourceMappingURL=PreDocumentCheckStep.js.map